import { t } from '@/locale/index.js'

/** 按 route.name 解析菜单标题（routing.js 保留中文作 fallback） */
export function menuTitle(routeItem) {
  if (!routeItem) return ''
  const name = routeItem.name
  if (name) {
    const key = `menu.${name}`
    const translated = t(key)
    if (translated !== key) return translated
  }
  return routeItem.title || ''
}

/** 浅拷贝路由节点并翻译 title（不修改原始 routing 配置） */
export function localizeRouteItem(routeItem) {
  if (!routeItem) return routeItem
  const copy = { ...routeItem, title: menuTitle(routeItem) }
  if (Array.isArray(routeItem.children)) {
    copy.children = routeItem.children.map((child) => localizeRouteItem(child))
  }
  return copy
}
